import NeoBrutalistHeatMap from "./search/components/NeoBrutalistHeatMap";
export default function NewsToday() {
  return (
    <div>
      <div className="w-full  max-w-7xl mx-auto mt-12 sm:mt-16 md:mt-20 mb-12 sm:mb-16 md:mb-20 px-4 sm:px-6 md:px-8 lg:px-12">
        <NeoBrutalistHeatMap />
      </div>
      {/* Built in public attribution */}
      <footer className="text-center text-sm text-gray-400 font-regular">
        <a
          href="https://www.linkedin.com/in/productmars/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-500 hover:text-blue-800 transition-colors duration-200 font-regular"
        >
          Built in public by Mars
        </a>{" "}
        🍦{" "}
        <a
          href="https://www.buymeacoffee.com/marsescobin"
          target="_blank"
          rel="noopener noreferrer"
          className=" transition-colors duration-200 text-green-500 hover:text-blue-800 font-regular"
        >
          Buy me a gelato
        </a>
      </footer>
    </div>
  );
}
